import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter, Route, Switch } from "react-router-dom"
import { StripeProvider } from "react-stripe-elements"
import { GetCorrectEnvPkKey } from "config"
import SetsterBooking from "../booking/SetsterBooking"
import withLocalized from "../localization/withLocalized"
import { SubPageContainer } from "../booking/components/BookingSubPage"
import {
  ModalContainer,
  ModalHeader,
  MenuButton,
  ContentContainer
} from "../common/components/modal/ui/"
import * as proActions from "../pros/actions"
import Icon from "../common/components/icon/Icon"
import { ICONS } from "../common/components/icon/Icons"
const prosPath = "(/embed)?/pros"
const proPath = `${prosPath}/:machine_name`
const proReservationPath = `${proPath}/book/:serviceId/:time`
const bookingSubPagePath = `${proReservationPath}/:subpage(help|terms|complete|error)?`

class SetsterBookingPage extends Component {
  componentDidMount() {
    document.body.classList.add("with-modal")
  }

  componentWillUnmount() {
    document.body.classList.remove("with-modal")
  }

  componentWillMount() {
    this.loadData()
  }

  loadData() {
    const { id, loadPro, loadPros } = this.props
    if (process.env.REACT_APP_SERVER_SIDE) {
      loadPros()
      loadPro(id)
    } else {
      loadPro(id)
    }
  }

  render() {
    const { match, localized, location, pro } = this.props
    const linkRoot = match.url.split("/book")[0]
    const onCloseLink = linkRoot
    const fromWidget = document.location.href.indexOf("embed") !== -1
    const onCloseClick = () => {
      const isEmbed = location.pathname.match(/^\/embed\/(.*)/)
      if (isEmbed) {
        try {
          if (window.parent && window.self !== window.top) {
            window.parent.window.postMessage("BTClose", "*")
          } else {
            window.close()
          }
        } catch (e) {}
      } else {
        onCloseLink
          ? this.props.history.replace(onCloseLink)
          : this.props.history.replace(`${linkRoot}`)
      }
    }

    return (
      <ModalContainer zIndex="2" first>
        <ModalHeader>
          <MenuButton />
          <h2>{localized("lesson_booking.form.modal_title")}</h2>
          {!fromWidget && (
            <MenuButton onClick={onCloseClick}>
              <Icon icon={ICONS.CLOSE} />
            </MenuButton>
          )}
        </ModalHeader>
        <ContentContainer>
          {pro && (
            <StripeProvider
              apiKey={GetCorrectEnvPkKey()}
              stripeAccount={pro.stripe_account_id}
            >
              <SetsterBooking {...this.props} />
            </StripeProvider>
          )}
        </ContentContainer>
        <Switch>
          <Route
            path={bookingSubPagePath}
            render={props => (
              <SubPageContainer {...props} onCloseLink={onCloseLink} />
            )}
          />
        </Switch>
      </ModalContainer>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { pros }
  } = state

  let id = ownProps.id || ownProps.match.params.id

  /*
    When url is used with server side machine_name we need to resolve accordingly
   */
  if (isNaN(parseInt(id, 10))) {
    for (const proId in pros) {
      if (
        pros[proId].hasOwnProperty("machine_name") &&
        pros[proId].machine_name === id
      ) {
        id = pros[proId].id
      }
    }
  }

  return {
    pro: pros[id] || undefined,
    id
  }
}

SetsterBookingPage = withRouter(
  connect(
    mapStateToProps,
    Object.assign({}, proActions)
    //actions
  )(SetsterBookingPage)
)

export default withLocalized(SetsterBookingPage)



// WEBPACK FOOTER //
// ./src/modules/pages/SetsterBookingPage.js